/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { employees_AvailabilityRangeResponse } from '../models/employees_AvailabilityRangeResponse';
import type { employees_CreateEmployeeRequest } from '../models/employees_CreateEmployeeRequest';
import type { employees_EmployeeAuditHistoryResponse } from '../models/employees_EmployeeAuditHistoryResponse';
import type { employees_EmployeeAuditRecord } from '../models/employees_EmployeeAuditRecord';
import type { employees_EmployeeAvailabilityResponse } from '../models/employees_EmployeeAvailabilityResponse';
import type { employees_EmployeeCountResponse } from '../models/employees_EmployeeCountResponse';
import type { employees_EmployeePickerResponse } from '../models/employees_EmployeePickerResponse';
import type { employees_EscalationPathResponse } from '../models/employees_EscalationPathResponse';
import type { employees_ExportEmployeesVCardRequest } from '../models/employees_ExportEmployeesVCardRequest';
import type { employees_LinkLoginRequest } from '../models/employees_LinkLoginRequest';
import type { employees_LinkLoginResponse } from '../models/employees_LinkLoginResponse';
import type { employees_LoginStatusResponse } from '../models/employees_LoginStatusResponse';
import type { employees_ProvisionLoginRequest } from '../models/employees_ProvisionLoginRequest';
import type { employees_ProvisionLoginResponse } from '../models/employees_ProvisionLoginResponse';
import type { employees_ReissueLoginResponse } from '../models/employees_ReissueLoginResponse';
import type { employees_RevokeLoginResponse } from '../models/employees_RevokeLoginResponse';
import type { employees_UpdateEmployeeRequest } from '../models/employees_UpdateEmployeeRequest';
import type { models_Employee } from '../models/models_Employee';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmployeesService {
    /**
     * List every employee's availability in a date range
     * The availability rules whose validity intersects [from, to] and the blocked days inside it, for all employees (issue #2041). The shift planner hatches unavailable hours and marks blocked days with it. At most 62 days.
     * @param from First day (YYYY-MM-DD)
     * @param to Last day (YYYY-MM-DD)
     * @returns employees_AvailabilityRangeResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeeAvailability(
        from: string,
        to: string,
    ): CancelablePromise<employees_AvailabilityRangeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-availability',
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                400: `Missing or invalid from/to, or more than 62 days`,
                401: `Authentication required`,
                403: `No shifts-absences access`,
                500: `Failed to load availability`,
            },
        });
    }
    /**
     * List employees
     * List employees with pagination
     * @param limit Limit
     * @param offset Offset
     * @returns models_Employee OK
     * @throws ApiError
     */
    public static getApiV1Employees(
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<models_Employee>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                500: `Failed to list employees`,
            },
        });
    }
    /**
     * Create an employee
     * Create a new employee
     * @param employee Employee data
     * @returns models_Employee Created
     * @throws ApiError
     */
    public static postApiV1Employees(
        employee: employees_CreateEmployeeRequest,
    ): CancelablePromise<models_Employee> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees',
            body: employee,
            errors: {
                400: `Validation errors or invalid request format`,
                422: `Unknown group or direct head, or an invalid allergy / emergency contact entry`,
                500: `Failed to create employee`,
            },
        });
    }
    /**
     * Delete an employee
     * Soft delete an employee
     * @param id Employee ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1Employees(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/employees/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing or invalid employee ID`,
                404: `Employee not found`,
                409: `Employee still has an active login`,
                500: `Failed to delete employee`,
            },
        });
    }
    /**
     * Get an employee by ID
     * Get an employee by ID
     * @param id Employee ID
     * @returns models_Employee OK
     * @throws ApiError
     */
    public static getApiV1Employees1(
        id: string,
    ): CancelablePromise<models_Employee> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing or invalid employee ID`,
                404: `Employee not found`,
                500: `Failed to get employee`,
            },
        });
    }
    /**
     * Update an employee
     * Update an existing employee
     * @param id Employee ID
     * @param employee Updated employee data
     * @returns models_Employee OK
     * @throws ApiError
     */
    public static putApiV1Employees(
        id: string,
        employee: employees_UpdateEmployeeRequest,
    ): CancelablePromise<models_Employee> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/employees/{id}',
            path: {
                'id': id,
            },
            body: employee,
            errors: {
                400: `Validation errors, invalid request format, or missing/invalid employee ID`,
                404: `Employee not found`,
                422: `Unknown group or direct head, derived status, or an invalid allergy / emergency contact entry`,
                500: `Failed to update employee`,
            },
        });
    }
    /**
     * Get an employee's availability
     * The employee's current weekly availability windows and blocked days from today on, as the employee entered them in the app (issue #2041). Read-only.
     * @param id Employee ID
     * @returns employees_EmployeeAvailabilityResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeesAvailability(
        id: string,
    ): CancelablePromise<employees_EmployeeAvailabilityResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{id}/availability',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid employee ID`,
                401: `Authentication required`,
                403: `No shifts-absences access`,
                404: `Employee not found`,
                500: `Failed to load availability`,
            },
        });
    }
    /**
     * Resolve the escalation target for an employee
     * Answers who receives work escalated from this employee, in an optional group context. NO_RECIPIENT and DEPTH_CAP_REACHED are valid 200 answers, not 404s.
     * @param id Employee ID
     * @param groupId Group context for the group-lead hop
     * @returns employees_EscalationPathResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeesEscalationPath(
        id: string,
        groupId?: string,
    ): CancelablePromise<employees_EscalationPathResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{id}/escalation-path',
            path: {
                'id': id,
            },
            query: {
                'group_id': groupId,
            },
            errors: {
                400: `Missing or invalid employee ID or group ID`,
                401: `Authentication required`,
                403: `Missing organization context`,
                500: `Failed to resolve the escalation path`,
            },
        });
    }
    /**
     * Get audit history for an employee
     * Get paginated audit history for a specific employee
     * @param id Employee ID
     * @param page Page number (default: 1)
     * @param limit Page size (default: 20, max: 100)
     * @returns employees_EmployeeAuditHistoryResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeesHistory(
        id: string,
        page?: number,
        limit?: number,
    ): CancelablePromise<employees_EmployeeAuditHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{id}/history',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Invalid parameters`,
                403: `Organization ID not found in token`,
                500: `Failed to get audit history`,
            },
        });
    }
    /**
     * Get field change history for an employee
     * Get the history of changes to a specific field
     * @param id Employee ID
     * @param field Field name
     * @returns employees_EmployeeAuditRecord OK
     * @throws ApiError
     */
    public static getApiV1EmployeesHistoryField(
        id: string,
        field: string,
    ): CancelablePromise<Array<employees_EmployeeAuditRecord>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{id}/history/field/{field}',
            path: {
                'id': id,
                'field': field,
            },
            errors: {
                400: `Invalid parameters`,
                403: `Organization ID not found in token`,
                404: `Unknown field`,
                500: `Failed to get field history`,
            },
        });
    }
    /**
     * Get recent changes for an employee
     * Get the last 10 changes to an employee
     * @param id Employee ID
     * @returns employees_EmployeeAuditRecord OK
     * @throws ApiError
     */
    public static getApiV1EmployeesHistoryRecent(
        id: string,
    ): CancelablePromise<Array<employees_EmployeeAuditRecord>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{id}/history/recent',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing employee ID`,
                403: `Organization ID not found in token`,
                500: `Failed to get recent changes`,
            },
        });
    }
    /**
     * Link an existing Clerk user to an employee
     * Link an existing Clerk user (found by the employee's email) to the employee and ensure org membership. No password is returned.
     * @param id Employee ID
     * @param request Login role
     * @returns employees_LinkLoginResponse OK
     * @throws ApiError
     */
    public static postApiV1EmployeesLinkLogin(
        id: string,
        request: employees_LinkLoginRequest,
    ): CancelablePromise<employees_LinkLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/{id}/link-login',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid employee ID`,
                401: `Authentication required (or user context missing)`,
                403: `Staff access required, admin access required to grant an admin login, or organization context missing`,
                404: `Employee not found`,
                409: `Login already linked or Clerk user taken by another employee or shared with another organisation (EMPLOYEE_LOGIN_SHARED_ACCOUNT)`,
                422: `Employee has no valid email`,
                500: `Failed to link login`,
                502: `Login provisioning failed`,
                503: `Login provisioning not configured`,
            },
        });
    }
    /**
     * Get an employee's login status
     * Return the detail-view login status (has login, auth role, and a best-effort "signed in" flag from a single Clerk lookup). The list view derives status from employee fields without this call.
     * @param id Employee ID
     * @returns employees_LoginStatusResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeesLoginStatus(
        id: string,
    ): CancelablePromise<employees_LoginStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{id}/login-status',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid employee ID`,
                401: `Authentication required`,
                403: `Staff access required or organization context missing`,
                404: `Employee not found`,
                500: `Failed to get login status`,
            },
        });
    }
    /**
     * Create an employee login
     * Create a Clerk login for an employee (admin/staff role) and return a one-time initial password.
     * @param id Employee ID
     * @param request Login role
     * @returns employees_ProvisionLoginResponse OK
     * @throws ApiError
     */
    public static postApiV1EmployeesProvisionLogin(
        id: string,
        request: employees_ProvisionLoginRequest,
    ): CancelablePromise<employees_ProvisionLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/{id}/provision-login',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid employee ID`,
                401: `Authentication required (or user context missing)`,
                403: `Staff access required, admin access required to grant an admin login, or organization context missing`,
                404: `Employee not found`,
                409: `Login already linked, Clerk user exists, or member limit reached`,
                422: `Employee has no valid email`,
                500: `Failed to provision login`,
                502: `Login provisioning failed`,
                503: `Login provisioning not configured`,
            },
        });
    }
    /**
     * Re-issue an employee login password
     * Generate a fresh one-time password for a linked employee (web-admin fallback for caregivers who don't use email). Returned exactly once.
     * @param id Employee ID
     * @returns employees_ReissueLoginResponse OK
     * @throws ApiError
     */
    public static postApiV1EmployeesReissueLogin(
        id: string,
    ): CancelablePromise<employees_ReissueLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/{id}/reissue-login',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid employee ID`,
                401: `Authentication required (or user context missing)`,
                403: `Admin access required or organization context missing`,
                404: `Employee not found`,
                409: `Employee login is not linked or shared with another organisation (EMPLOYEE_LOGIN_SHARED_ACCOUNT)`,
                500: `Failed to re-issue login`,
                502: `Login provisioning failed`,
                503: `Login provisioning not configured`,
            },
        });
    }
    /**
     * Revoke an employee login
     * Deletes the employee's Clerk organization membership and clears the local login link (clerkUserId, authRole, loginProvisionedAt). The Clerk USER is never deleted — the same person may be a parent, or may be re-linked later. A "not a member" answer from Clerk counts as success, so the call is idempotent. A 409 with code EMPLOYEE_LOGIN_CONCURRENT_MODIFICATION means another writer changed the login link (a concurrent provision, re-issue or soft-delete) between the read and the clear: the Clerk membership IS already gone, so access is revoked — reload the employee and re-check the record. A 409 with code EMPLOYEE_LOGIN_NOT_LINKED means the employee had no login to revoke. When a live contact in the organization shares the same Clerk user (a staff member who is also a parent), the membership is kept for the parent login and status reads "Login unlinked, parent login kept". An org:admin membership kept this way is first downgraded to org:member, so the person keeps only the parent login.
     * @param id Employee ID
     * @returns employees_RevokeLoginResponse OK
     * @throws ApiError
     */
    public static postApiV1EmployeesRevokeLogin(
        id: string,
    ): CancelablePromise<employees_RevokeLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/{id}/revoke-login',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid employee ID`,
                401: `Authentication required (or user context missing)`,
                403: `Admin access required, cannot revoke your own login, or organization context missing`,
                404: `Employee not found`,
                409: `Employee has no login (EMPLOYEE_LOGIN_NOT_LINKED) or the login changed concurrently (EMPLOYEE_LOGIN_CONCURRENT_MODIFICATION)`,
                500: `Failed to revoke login`,
                502: `Clerk request failed`,
                503: `Login provisioning not configured`,
            },
        });
    }
    /**
     * Get an employee with related data
     * Get an employee by ID with qualification and address data
     * @param id Employee ID
     * @returns models_Employee OK
     * @throws ApiError
     */
    public static getApiV1EmployeesWithRelations(
        id: string,
    ): CancelablePromise<models_Employee> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/{id}/with-relations',
            path: {
                'id': id,
            },
            errors: {
                400: `Missing or invalid employee ID`,
                404: `Employee not found`,
                500: `Failed to get employee with relations`,
            },
        });
    }
    /**
     * Count employees
     * Count non-deleted employees for the org, optionally filtered by a comma-separated status list. Used by the Analytics "Active employees" KPI so it reflects the whole org instead of a single page.
     * @param status Comma-separated status filter (ACTIVE, INACTIVE, UPCOMING)
     * @returns employees_EmployeeCountResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeesCount(
        status?: string,
    ): CancelablePromise<employees_EmployeeCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/count',
            query: {
                'status': status,
            },
            errors: {
                400: `Invalid status value`,
                403: `Organization ID not found in token`,
                500: `Failed to count employees`,
            },
        });
    }
    /**
     * Export employees as vCard phone book
     * Returns a .vcf file (vCard 3.0, UTF-8) with one card per employee, for import into phone address books. Every name starts with "KITA".
     * @param request Employee IDs to export
     * @returns binary vCard file download
     * @throws ApiError
     */
    public static postApiV1EmployeesExportVcf(
        request: employees_ExportEmployeesVCardRequest,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employees/export/vcf',
            body: request,
            errors: {
                400: `Invalid request body or too many IDs`,
                401: `Authentication required or invalid credentials`,
                403: `Employees module required, or organization ID not found in token`,
                500: `Internal server error`,
                503: `vCard export not configured`,
            },
        });
    }
    /**
     * Filter employees by qualification level
     * Filter employees by qualification level
     * @param qualificationLevel Qualification level
     * @returns models_Employee OK
     * @throws ApiError
     */
    public static getApiV1EmployeesFilterQualificationLevel(
        qualificationLevel: 'QUALIFIED' | 'RECOGNITION_PENDING' | 'NOT_QUALIFIED',
    ): CancelablePromise<Array<models_Employee>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/filter/qualification-level/{qualificationLevel}',
            path: {
                'qualificationLevel': qualificationLevel,
            },
            errors: {
                400: `Missing qualification level parameter`,
                500: `Failed to filter employees`,
            },
        });
    }
    /**
     * List the employee picker
     * Slim employee rows for name pickers and name lookups: id, first and last name, status,
     * group ids and the Clerk user id (when the employee has a login) of every non-deleted
     * employee, ordered by last name. Admits any module holder (issue #1688); the full
     * employee records stay behind EMP_LIST.
     * @returns employees_EmployeePickerResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeesPicker(): CancelablePromise<employees_EmployeePickerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/picker',
            errors: {
                401: `Authentication required`,
                403: `Organization ID not found in token, or no module granted`,
                500: `Failed to list employees`,
            },
        });
    }
    /**
     * Search employees by name
     * Search employees by first name or last name
     * @param name Employee name
     * @param limit Limit
     * @param offset Offset
     * @returns models_Employee OK
     * @throws ApiError
     */
    public static getApiV1EmployeesSearch(
        name: string,
        limit: number = 10,
        offset?: number,
    ): CancelablePromise<Array<models_Employee>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employees/search',
            query: {
                'name': name,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Missing name parameter`,
                500: `Failed to search employees`,
            },
        });
    }
}
